import React, { useRef, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { action } from 'mobx';

import { Campaign } from 'models/Campaign';

import Switch from '@vromo/ui/components/Switch';
import Table from '@vromo/ui/components/Table';
import Button from '@vromo/ui/components/Button';
import WidgetEditor from './WidgetEditor';
import WidgetRow from './components/WidgetRow';
import { qaLabelCampaigns } from './../../../../../../../common-qa-labels/campaigns';

const LOCALE_ENABLED = 'Enabled';
const LOCALE_ADD_WIDGET = '+ Add Widget';
const LOCALE_TYPE = 'Type';
const LOCALE_VALUE = 'Value';

interface Props {
    campaign: Campaign;
}

export default observer<Props>(function Widgets({ campaign }) {
    const editorViewRef = useRef(null);
    const [promoEditorOpen, setPromoEditorOpen] = useState(false);

    const openEditor = () => {
        setPromoEditorOpen(true);
        setTimeout(() => editorViewRef?.current?.scrollIntoView({ behavior: 'smooth' }), 40);
    };

    return (
        <div>
            <div>
                <label>{LOCALE_ENABLED}</label>
                <Switch
                    testId={qaLabelCampaigns.editModal.enableWidgetBtn}
                    style={{ margin: '0 16px' }}
                    checked={campaign.promotion?.enabled}
                    onChange={action((enabled) => (campaign.promotion.enabled = enabled))}
                />
            </div>

            <hr />

            <Table>
                <thead>
                    <tr>
                        <th />
                        <th>{LOCALE_TYPE}</th>
                        <th>{LOCALE_VALUE}</th>
                    </tr>
                </thead>
                <tbody data-testid={qaLabelCampaigns.editModal.widgetBodyTable}>
                    {campaign.widgets
                        ? campaign.widgets.map((widget) => (
                              <WidgetRow key={widget.id} campaign={campaign} widget={widget} />
                          ))
                        : null}
                </tbody>
            </Table>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    data-testid={qaLabelCampaigns.editModal.addWidgetBtn}
                    primary
                    onClick={openEditor}>
                    {LOCALE_ADD_WIDGET}
                </Button>
            </div>
            {promoEditorOpen ? (
                <div ref={editorViewRef}>
                    <WidgetEditor campaign={campaign} close={() => setPromoEditorOpen(false)} />
                </div>
            ) : null}
        </div>
    );
});
